/* Geist V9 – Megoldás-kereső (űrlapmotor). Adat: <script id="v9fa-kereso"> (a fa.py-ból generálva) + <script data-v9k-url> (handle → URL).
   Menet: K1 tárgy → K2 anyag (Nem tudom: vízcsepp-próba) → K3 gond → K4 pontosítás (ha kell) → átnavigálás az eredményoldalra
   (?k1=…&k2=…&k3=…&k4=…&k=kereso), vagy MEGÁLLJ-doboz (szakember-kereső + fotó). Előtöltés: data-pre és az URL k1–k4 paraméterei.
   Mérés: geist_urlap_start / geist_urlap_kesz (Shopify.analytics.publish + gtag, ha van). BUILD-01, 2026-10-14. */
(function () {
  function init(box) {
    if (box.dataset.init) return; box.dataset.init = '1';
    var faEl = document.getElementById('v9fa-' + (box.dataset.fa || 'kereso'));
    var app = box.querySelector('[data-v9k-app]');
    if (!faEl || !app) return;
    var FA = JSON.parse(faEl.textContent), URLS = {};
    try { URLS = JSON.parse(box.querySelector('[data-v9k-url]').textContent || '{}'); } catch (e) {}
    var SZAKEMBER = '/pages/borjavito-szakember-kereso';
    var a = {}, hist = [], started = false;
    var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    function track(n, d) {
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(n, d); } catch (e) {}
      try { if (typeof window.gtag === 'function') window.gtag('event', n, d); } catch (e) {}
    }
    function lbl(list, code) { for (var i = 0; i < list.length; i++) if (list[i][0] === code) return list[i][1]; return code; }
    function k2ok(k1, k2) { return FA.k2.some(function (r) { return r[0] === k2 && r[2].indexOf(k1) > -1; }); }

    /* előtöltés: data-pre, majd az URL (csak a kereső saját oldalán / horgonyánál) */
    var pre = new URLSearchParams(box.dataset.pre || '');
    var u = new URLSearchParams(location.search);
    if (u.get('k1') || u.get('k2') || u.get('k3')) pre = u;
    ['k1', 'k2', 'k3', 'k4'].forEach(function (k) { if (pre.get(k)) a['p' + k] = pre.get(k); });

    function screen(step, q, s, opts, onPick, total) {
      var pct = Math.round((step - 1) / (total || 4) * 100);
      var h = '<div class="v9k__bar"><span>' + step + '. kérdés</span><span class="v9k__prog" aria-hidden="true"><i style="width:' + pct + '%"></i></span></div>' +
        '<p class="v9k__q" tabindex="-1">' + esc(q) + '</p>' + (s ? '<p class="v9k__s">' + esc(s) + '</p>' : '') +
        '<div class="v9k__opts" role="group" aria-label="' + esc(q) + '">' + opts.map(function (o) {
          return '<button type="button" class="v9-opt" data-c="' + esc(o[0]) + '">' + esc(o[1]) + '</button>';
        }).join('') + '</div>' +
        '<div class="v9k__nav"><button type="button" class="v9k__back"' + (hist.length ? '' : ' hidden') + '>← Vissza</button></div>';
      app.innerHTML = h;
      app.querySelectorAll('.v9-opt').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!started) { started = true; track('geist_urlap_start', { urlap: 'kereso', forras: box.dataset.src || '' }); }
          onPick(b.dataset.c);
        });
      });
      var back = app.querySelector('.v9k__back');
      back.addEventListener('click', function () { var f = hist.pop(); if (f) f(); });
      if (box.dataset.focus) { var qe = app.querySelector('.v9k__q'); if (qe) qe.focus({ preventScroll: true }); }
      box.dataset.focus = '1';
    }
    function go(fn, back) { if (back) hist.push(back); fn(); }

    function K1() {
      a = { pk2: a.pk2, pk3: a.pk3, pk4: a.pk4 };
      if (a.pk1 && FA.k1.some(function (r) { return r[0] === a.pk1; })) { var v = a.pk1; delete a.pk1; a.k1 = v; hist.push(K1); return K2(); }
      screen(1, FA.k1q, FA.k1s, FA.k1, function (c) { a.k1 = c; go(K2, K1); });
    }
    function K2() {
      var opts = FA.k2.filter(function (r) { return r[2].indexOf(a.k1) > -1; }).map(function (r) { return [r[0], r[1]]; });
      if (a.pk2) { var v = a.pk2; delete a.pk2; if (v === 'nemtudom' && k2ok(a.k1, v)) { hist.push(K2); return W1(); } if (k2ok(a.k1, v)) { a.k2 = v; hist.push(K2); return K3(); } }
      screen(2, FA.k2q, FA.k2s, opts, function (c) {
        if (c === 'nemtudom') return go(W1, K2);
        a.k2 = c; go(K3, K2);
      });
    }
    /* „Nem tudom” anyag: vízcsepp-próba (01-terv K2) */
    function W1() {
      screen(2, 'Vízcsepp-próba: mi történt a cseppel?', 'Cseppents egy csepp vizet egy rejtett helyre.', [['meg', 'Megült a csepp (gyöngyözik)'], ['be', 'Beszívódott, sötét foltot hagyott']], function (c) {
        go(c === 'meg' ? W2 : W3, W1);
      });
    }
    function W2() {
      screen(2, 'Milyen a hátoldala?', 'Jellemző a műbőrre, hogy textilből van a hátulja, és egyenletes a mintázata.', [['mubor', 'Textil a hátoldala (műbőr)'], ['bor', 'Nem textil, vagy nem látom (sima bőr)']], function (c) { pick2(c, W2); });
    }
    function W3() {
      screen(2, 'Milyen a tapintása?', '', [['anilin', 'Sima tapintású (anilin)'], ['velur', 'Bársonyos (velúr, nubuk)']], function (c) { pick2(c, W3); });
    }
    function pick2(c, back) { if (!k2ok(a.k1, c)) { hist.push(back); return stop('M0'); } a.k2 = c; go(K3, back); }
    function K3() {
      var allowed = FA.k3e[a.k1 + '|' + a.k2] || [];
      if (a.pk3) { var v = a.pk3; delete a.pk3; if (allowed.indexOf(v) > -1) { a.k3 = v; hist.push(K3); return K4(); } }
      var opts = FA.k3.filter(function (r) { return allowed.indexOf(r[0]) > -1; });
      screen(3, FA.k3q, FA.k3s, opts, function (c) { a.k3 = c; go(K4, K3); });
    }
    function K4() {
      var kv = FA.k4v[a.k1 + '|' + a.k2 + '|' + a.k3];
      if (!kv) { a.k4 = ''; return done(); }
      var d = FA.k4[kv];
      if (a.pk4) { var v = a.pk4; delete a.pk4; if (d.o.some(function (r) { return r[0] === v; })) { a.k4 = v; hist.push(K4); return done(); } }
      screen(4, d.q, d.s, d.o, function (c) {
        if (c === 'nemtudom' && kv === 'kor') return go(K4kor, K4);
        a.k4 = c; hist.push(K4); done();
      });
    }
    function K4kor() {
      screen(4, 'Keményebbnek érződik, vagy látsz apró repedéseket?', '', [['3plus', 'Igen'], ['0-3', 'Nem']], function (c) { a.k4 = c; hist.push(K4kor); done(); });
    }
    function done() {
      var k4 = a.k4 || '';
      var key = a.k1 + '|' + a.k2 + '|' + a.k3 + '|' + (k4 === 'nemtudom' ? 'igen' : k4);
      var cel = FA.cel[key];
      if (!cel && a.k3 === 'nemtudom') cel = 'M0';
      if (!cel) cel = 'M0';
      track('geist_urlap_kesz', { urlap: 'kereso', eredmeny: cel, k1: a.k1, k2: a.k2, k3: a.k3, k4: k4 });
      if (/^M\d$/.test(cel)) return stop(cel);
      var url = URLS[cel];
      if (!url) return stop('M0');
      var p = new URLSearchParams(); p.set('k1', a.k1); p.set('k2', a.k2); p.set('k3', a.k3); if (k4) p.set('k4', k4); p.set('k', 'kereso');
      app.innerHTML = '<div class="v9k__res"><h3>Megvan: ' + esc((FA.t[cel] || {}).c || '') + '</h3><p>Átviszünk a lépésekhez…</p></div>';
      if (typeof window.v9kNav === 'function') return window.v9kNav(url + '?' + p.toString()); /* automata bejáráshoz (QA) */
      location.href = url + '?' + p.toString();
    }
    function stop(code) {
      var m = FA.m[code] || FA.m.M0;
      var alt = m.a && URLS[m.a] ? '<a class="v9-btn v9-btn--ghost v9-btn--sm" href="' + esc(URLS[m.a]) + '">' + esc((FA.t[m.a] || {}).c || 'Megnézem') + '</a>' : '';
      app.innerHTML = '<div class="v9k__res v9-stop"><h3>' + esc(m.c) + '</h3><p>' + esc(m.s) + '</p><div class="v9-stop__a">' +
        '<a class="v9-btn v9-btn--sm" href="' + SZAKEMBER + '">Szakember-kereső</a>' +
        '<a class="v9-btn v9-btn--ghost v9-btn--sm" href="mailto:hello@geistshop.hu?subject=' + encodeURIComponent('Fotó a problémáról') + '">Fotó küldése: hello@geistshop.hu</a>' + alt +
        '</div></div><div class="v9k__nav"><button type="button" class="v9k__back">← Vissza</button><button type="button" class="v9k__back" data-r>Újrakezdem</button></div>';
      var bs = app.querySelectorAll('.v9k__back');
      bs[0].addEventListener('click', function () { var f = hist.pop(); if (f) f(); else K1(); });
      bs[1].addEventListener('click', function () { hist = []; a = {}; K1(); });
    }
    box.v9kReset = function () { hist = []; a = {}; started = true; K1(); };
    K1();
  }
  function boot() { document.querySelectorAll('[data-v9k]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
